'use client';

import React from 'react';
import { OnboardingProvider, useOnboarding } from '@/contexts/onboarding-context';
import { TutorialProvider } from '@/contexts/tutorial-context';
import { OnboardingDialog } from './onboarding-dialog';
import { useUser } from '@/contexts/user-context';
import Loading from '../loading';

interface OnboardingWrapperProps {
  children: React.ReactNode;
}

function OnboardingContent({ children }: OnboardingWrapperProps) {
  const { onboardingData } = useOnboarding();

  if (onboardingData?.isCompleted) return children;

  return (
    <>
      <Loading className="min-h-screen" />
      <OnboardingDialog />
    </>
  );
}

export function OnboardingWrapper({ children }: OnboardingWrapperProps) {
  const { user } = useUser();

  // Always wrap with TutorialProvider first
  return (
    <TutorialProvider>
      {user.isOnboardingCompleted ? (
        // User has completed onboarding, show normal app
        children
      ) : (
        // User needs onboarding
        <OnboardingProvider>
          <OnboardingContent>{children}</OnboardingContent>
        </OnboardingProvider>
      )}
    </TutorialProvider>
  );
}
